const offers = [
  {
    id: 2,
    title: 'Iznajmljivanje jahte',
    image: [
      require('../../../assets/images/offers/yacht0.jpg'),
      require('../../../assets/images/offers/yacht1.jpeg'),
      require('../../../assets/images/offers/yacht2.jpeg'),
      require('../../../assets/images/offers/yacht3.jpeg'),
      require('../../../assets/images/offers/yacht4.jpeg'),
    ],
  },
  {
    id: 1,
    title: 'Iznajmljivanje čamca',
    image: [
      require('../../../assets/images/offers/speedboat3.jpeg'),
      require('../../../assets/images/offers/speedboat0.jpg'),
      require('../../../assets/images/offers/speedboat1.jpeg'),
      require('../../../assets/images/offers/speedboat2.jpeg'),
    ],
  },
  {
    id: 3,
    image: [
      require('../../../assets/images/offers/submarine0.jpeg'),
      require('../../../assets/images/offers/submarine1.jpeg'),
      require('../../../assets/images/offers/submarine2.jpeg'),
      require('../../../assets/images/offers/submarine3.jpeg'),
    ],
    title: 'Vožnja polupodmornicom',
  },
  {
    id: 5,
    image: [
      require('../../../assets/images/offers/cellebration0.jpeg'),
      require('../../../assets/images/offers/cellebration1.jpeg'),
      require('../../../assets/images/offers/cellebration2.jpeg'),
      require('../../../assets/images/offers/cellebration3.jpeg'),
    ],
    title: 'Posebni dogadjaji',
  },
  {
    id: 4,
    title: 'Privatna plaža',
    image: [
      require('../../../assets/images/offers/beach3.jpeg'),
      require('../../../assets/images/offers/beach2.jpeg'),
      require('../../../assets/images/offers/beach1.jpeg'),
      require('../../../assets/images/offers/beach4.jpeg'),
    ],
  },
];

export default offers;
